export default {"src":"/_next/static/media/phone-icon.d0f3520a.svg","height":32,"width":32};